import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/back.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-d8457c7e")

_pushScopeId("data-v-d8457c7e")
const _hoisted_1 = { style: {"padding":"0 30px","margin-top":"-30px"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "m-right-sm",
  src: _imports_0
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "color-danger p-top-bottom-md"
}
const _hoisted_4 = { class: "m-top-md auto-pay-table-title" }
const _hoisted_5 = { class: "p-top-bottom-md bottom-border" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_billing_info = _resolveComponent("billing-info")
  const _component_custom_table = _resolveComponent("custom-table")
  const _component_panel_list = _resolveComponent("panel-list")
  const _component_custom_button = _resolveComponent("custom-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("b", {
      class: "back-text cursor-pointer p-bottom-md",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
    }, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(`${_ctx.$wordList.ProperAllTextBack}`), 1)
    ]),
    (_ctx.autoPayInfo.Reason!==-1)
      ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.autoPayCancleReasonMap[_ctx.autoPayInfo.Reason]), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_billing_info, {
      class: "p-top-md",
      "user-type": _ctx.props.userType
    }, null, 8, ["user-type"]),
    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$wordList.NItems.format(`${_ctx.autoPayInfo.Items.length}`)), 1),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_custom_table, {
        class: "auto-pay-table",
        column: _ctx.column,
        tableData: _ctx.autoPayInfo.Items,
        onSortChange: _ctx.tableSortChange,
        "default-sort": _ctx.defaultTableSort
      }, {
        nextPayTime: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.autoPayInfo['NextPayTime']), 1)
        ]),
        _: 1
      }, 8, ["column", "tableData", "onSortChange", "default-sort"])
    ]),
    _createVNode(_component_panel_list, {
      column: _ctx.panelListColumn,
      data: _ctx.autoPayInfo
    }, {
      IntervalType: _withId((scope) => [
        _createTextVNode(_toDisplayString(_ctx.intervalTypeMap[scope.value]) + " (" + _toDisplayString(_ctx.autoPayInfo['TimeZone']) + ") ", 1)
      ]),
      Cycles: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.autoPayInfo['Cycles']===0?_ctx.$wordList.Unlimited:_ctx.autoPayInfo['Cycles']), 1)
      ]),
      number: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.autoPayInfo.Items.length), 1)
      ]),
      TotalPriceTitle: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.intervalTypeMapTitle[_ctx.autoPayInfo['IntervalType']]), 1)
      ]),
      NextPayTime: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.autoPayInfo['NextPayTime']||'--'), 1)
      ]),
      TotalPrice: _withId((scope) => [
        _createTextVNode(" $" + _toDisplayString(scope.value), 1)
      ]),
      _: 1
    }, 8, ["column", "data"]),
    (_ctx.autoPayInfo.Status===0)
      ? (_openBlock(), _createBlock(_component_custom_button, {
          key: 1,
          onClick: _ctx.cancelPlan
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.CancelPlan), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.autoPayInfo.Status===1)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_custom_button, {
            type: "primary",
            onClick: _ctx.editAutoPay
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlModify), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_custom_button, { onClick: _ctx.cancelPlan }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.CancelPlan), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.autoPayInfo.Status===2||_ctx.autoPayInfo.Status===3||_ctx.autoPayInfo.Status===4||_ctx.autoPayInfo.Status===5||_ctx.autoPayInfo.Status===6)
      ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
          _createVNode(_component_custom_button, {
            type: "primary",
            onClick: _ctx.editAutoPay
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlModify), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_custom_button, { onClick: _ctx.delAutoPayRecord }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlDelete), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})